import React from 'react';
import { ShieldCheck, Lock, ShieldAlert, Server, Globe, Database } from 'lucide-react';

const Security = () => {
  const certifications = [
    { icon: <ShieldCheck size={32} />, title: "Secure Architecture", subtitle: "Best Practices" },
    { icon: <ShieldAlert size={32} />, title: "Privacy-Focused", subtitle: "Data Safety" },
    { icon: <Lock size={32} />, title: "AES-256", subtitle: "Encryption" }
  ];

  return (
    <section id="security" className="security-section section-padding">
      <div className="container">
        <div className="security-card">
          <div className="security-header">
            <h2>Built for Enterprise Security & Reliability</h2>
            <p>Designed with industry-standard security best practices and secure data handling practices.</p>
          </div>

          <div className="security-grid">
            <div className="security-info">
              <div className="info-item">
                <div className="info-icon-wrapper">
                  <Server className="info-icon" />
                </div>
                <div>
                  <h4>Managed Infrastructure</h4>
                  <p>Securely hosted on Raptic91<sup>™</sup>-managed infrastructure, ensuring isolation and performance.</p>
                </div>
              </div>
              <div className="info-item">
                <div className="info-icon-wrapper">
                  <Database className="info-icon" />
                </div>
                <div>
                  <h4>Data Isolation</h4>
                  <p>Complete logical isolation of customer data with dedicated encryption keys and secure storage.</p>
                </div>
              </div>
              <div className="info-item">
                <div className="info-icon-wrapper">
                  <Globe className="info-icon" />
                </div>
                <div>
                  <h4>Single Sign-On (SSO)</h4>
                  <p>Seamless integration with Okta, Azure AD, and SAML 2.0 for enterprise identity management.</p>
                </div>
              </div>
            </div>

            <div className="security-certs">
              {certifications.map((cert, index) => (
                <div key={index} className="cert-item">
                  <div className="cert-icon-wrapper">
                    {cert.icon}
                  </div>
                  <div className="cert-text">
                    <div className="cert-title">{cert.title}</div>
                    <div className="cert-subtitle">{cert.subtitle}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Security;
